import React, {Component} from 'react';
import './App.css';

import MainApp from './include/MainApp.js';
import GetApp from './include/GetApp.js';

import SnowStorm from 'react-snowstorm';
import './include/_Api.js';


class App extends Component {

    constructor(props) {
        super(props);

        this.state = {isLoading : true};

        this.DetectUser = this.DetectUser.bind(this);
        this.UserDevice = {};
        this.language = "en";


        this.allowedLanguages = ["en", "it"];

        this.DetectUser();
    }

    DetectUser() {

        this.UserDevice['mobile'] = false;

        try {
            if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
                this.UserDevice['mobile'] = true;
            }

            let isChrome = /Chrome/.test(navigator.userAgent) && /Google Inc/.test(navigator.vendor);

            this.UserDevice['chrome'] = isChrome;
        }
        catch (err) {
        }

        try {
            let userLang = navigator.language || navigator.userLanguage;

            if (userLang.indexOf("it") !== -1) {
                this.language = "it";
            }

        }
        catch (err) {
        }
    }


    render() {


        let Snow = null;


        if (this.UserDevice['mobile'] === false && this.UserDevice['chrome'] === true) {
            Snow = <SnowStorm style={{position: 'fixed'}}/>;
        }

        return (
            <div className="App">

                <GetApp main={this}/>

                {Snow}

                <MainApp main={this}/>


            </div>
        );
    }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js